import type { ComponentType } from 'react';

import { componentWithCondition } from '@confluence/feature-gating-utils';
import { fg } from '@confluence/feature-gating';

export const componentWithFG = <A extends {}, B extends {}>(
	gateName: string,
	ComponentTrue: ComponentType<A>,
	ComponentFalse: ComponentType<B>,
): ReturnType<typeof componentWithCondition<A, B>> =>
	// eslint-disable-next-line confluence-feature-gating/static-feature-gates, confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
	componentWithCondition(() => fg(gateName), ComponentTrue, ComponentFalse);
